import { useContext } from 'react';
import { StateContext } from '../container/StateProvider/StateProvider';

function useState(nameSpace) {
  const state = useContext(StateContext);
  return nameSpace ? state[nameSpace] : state;
}

export default useState;
